var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14.6667C5 9.32791 9.32791 5 14.6667 5C20.0054 5 24.3333 9.32791 24.3333 14.6667C24.3333 17.2806 23.2958 19.6523 21.6101 21.3922C21.5691 21.4223 21.5298 21.4558 21.4928 21.4929C21.4557 21.5299 21.4222 21.5692 21.3921 21.6102C19.6522 23.2959 17.2806 24.3333 14.6667 24.3333C9.32791 24.3333 5 20.0054 5 14.6667ZM22.1789 23.5932C20.1492 25.3031 17.5283 26.3333 14.6667 26.3333C8.22334 26.3333 3 21.11 3 14.6667C3 8.22334 8.22334 3 14.6667 3C21.11 3 26.3333 8.22334 26.3333 14.6667C26.3333 17.5283 25.303 20.1494 23.5931 22.179L28.707 27.2929C29.0975 27.6834 29.0975 28.3166 28.707 28.7071C28.3165 29.0976 27.6833 29.0976 27.2928 28.7071L22.1789 23.5932Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d926b52e758e66b13eee0002eb76650f.svg";
export { ForwardRef as ReactComponent };